import React from "react"
import classNames from "classnames"
import styles from "./BaseError.module.css"

export function BaseError(props) {
    const {error, className} = props
    return <p className={classNames(styles.error, className)}>{error}</p>
}
